import { render, staticRenderFns } from "./sales-record.vue?vue&type=template&id=414234b7&scoped=true"
import script from "./sales-record.vue?vue&type=script&lang=ts"
export * from "./sales-record.vue?vue&type=script&lang=ts"
import style0 from "./sales-record.vue?vue&type=style&index=0&id=414234b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414234b7",
  null
  
)

export default component.exports